<!--
 * @Author: FengHang
 * @LastEditors: FengHang
 * @Date: 2021-09-24 11:35:22
 * @LastEditTime: 2021-12-21 15:10:10
-->
<template>
  <div class="aboutUs">
    <div class="aboutUs-inner">
      <div class="aboutUs-title">
        <img src="@/assets/images/arrowL.png" alt="" />
        <div class="">杭州荣鼎科技有限公司</div>
        <img src="@/assets/images/arrowR.png" alt="" />
      </div>
      <div class="aboutUs-desc">
        <div class="value">
          杭州荣鼎科技是一家现代服务型的科技企业，专注于企业服务领域，致力于成为100万家企业的首选合作伙伴。
        </div>
        <div class="value">
          荣鼎始终坚守让每一份信任不被辜负的使命，坚持全直营的互联网企业服务。
        </div>
        <div class="value">
          旗下有IT技术服务、人力资源服务、职业教育服务、数字营销服务四大直营业务板块。
        </div>
      </div>
      <div class="aboutUs-imgs">
        <img v-for="(item, index) in imgList" :key="index" :src="item.url" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          url: require('@/assets/images/img1.png')
        },
        {
          url: require('@/assets/images/img2.png')
        },
        {
          url: require('@/assets/images/img3.png')
        }
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.aboutUs {
  display: flex;
  align-items: center;
  justify-content: center;
  .aboutUs-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    .aboutUs-title {
      line-height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 40px;
      div {
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        margin: 0 20px;
      }
      img {
        width: 45px;
        height: 45px;
      }
    }
    .aboutUs-desc {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
      color: #999999;
      margin-bottom: 32px;
      .value {
      }
    }
    .aboutUs-imgs {
      display: flex;
      align-items: center;
      min-height: 404px;
      img {
        width: 400px;
        height: 404px;
      }
    }
  }
}
</style>
